import { render, staticRenderFns } from "./VlNavbar.vue?vue&type=template&id=37f6eeea&scoped=true&"
import script from "./VlNavbar.vue?vue&type=script&lang=js&"
export * from "./VlNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6eeea",
  null
  
)

export default component.exports